export const NetworkServiceEMSMapping = {
    data_roaming_eu: { name: "dataRoamingLimit", onValue: true },
    premium_services: { name: "premiumBarring", onValue: true },
    data_roaming: { name: "dataRoaming", onValue: true },
};
export var ECustomerProductStatus;
(function (ECustomerProductStatus) {
    ECustomerProductStatus[ECustomerProductStatus["Active"] = 0] = "Active";
    ECustomerProductStatus[ECustomerProductStatus["Suspended"] = 1] = "Suspended";
    ECustomerProductStatus[ECustomerProductStatus["Lost"] = 2] = "Lost";
    ECustomerProductStatus[ECustomerProductStatus["Deactivated"] = 3] = "Deactivated";
})(ECustomerProductStatus || (ECustomerProductStatus = {}));
